import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomiraroadcab() {



  const cardData = {


  keyword: "Pune to Mira Road Cab",

  headingDescription: "Trustline Cab provides reliable Pune to Mira Road cab services with safe, comfortable, and affordable transportation for corporate travel, business meetings, airport transfers, family visits, medical appointments, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups and a smooth, stress-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mira Road taxi services.",

  topPlaces: [
    {
      title: "Mira Road East",
      description: "Mira Road East is a rapidly developing commercial and residential locality featuring business centers, educational institutions, hospitals, shopping complexes, and modern infrastructure. Its excellent connectivity to Mumbai and Navi Mumbai makes it a preferred destination for professionals, families, and daily commuters."
    },
    {
      title: "Mira Road West",
      description: "Mira Road West is known for its vibrant residential communities, retail outlets, commercial establishments, and convenient access to western Mumbai. The locality offers a blend of modern amenities, business opportunities, and excellent transport connectivity for visitors."
    },
    {
      title: "Bhayandar",
      description: "Bhayandar is an important suburban destination with commercial markets, corporate offices, healthcare facilities, educational institutions, and seamless connectivity through road and railway networks. It serves as a key location for business travelers and family visits."
    },
    {
      title: "Dahisar",
      description: "Dahisar is the northern gateway to Mumbai, offering business establishments, residential townships, shopping centers, and excellent metro and highway connectivity. It is a convenient destination for corporate travelers and passengers entering Mumbai."
    },
    {
      title: "Western Express Highway",
      description: "The Western Express Highway is one of Mumbai's most important transport corridors, connecting Mira Road with Bandra, Andheri, the airport, and South Mumbai. It provides fast and convenient access for business, airport, and intercity travel."
    },
    {
      title: "Gorai Beach",
      description: "Gorai Beach is a peaceful coastal destination known for its scenic shoreline, ferry rides, seaside resorts, and relaxing atmosphere. It is a popular weekend getaway for families, couples, and tourists looking to unwind near Mumbai."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is an internationally renowned meditation center featuring one of the world's largest stone domes. The peaceful surroundings, impressive architecture, and spiritual environment attract visitors from across India and abroad."
    },
    {
      title: "EsselWorld Waterfront",
      description: "The EsselWorld waterfront area near Gorai offers scenic coastal views, ferry access, family-friendly attractions, and recreational activities. It is a popular destination for leisure travelers and visitors exploring Mumbai's western coastline."
    },
    {
      title: "Kanakia Business Park",
      description: "Kanakia Business Park is a modern commercial complex featuring corporate offices, business centers, professional workspaces, and excellent infrastructure. It serves as an important destination for business meetings and corporate activities in the Mira-Bhayandar region."
    },
    {
      title: "Vasai Fort",
      description: "Vasai Fort is a historic Portuguese-era monument surrounded by lush greenery and scenic landscapes. Known for its remarkable architecture and cultural heritage, it attracts history enthusiasts, photographers, and tourists throughout the year."
    }
  ],






"services": [
  {
    "name": "Pune to Mira Road Cab",
    "description": "Book Pune to Mira Road Cab for safe, comfortable, and affordable intercity travel with professional chauffeurs and clean AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, and premium cars for one-way trips, round trips, airport transfers, corporate travel, family vacations, business meetings, and weekend journeys. Enjoy doorstep pickup, transparent pricing, flexible travel schedules, sanitized vehicles, spacious luggage capacity, and 24x7 customer support for a smooth Pune to Mira Road journey."
  },
  {
    "name": "Pune to Mira Road Cab Service",
    "description": "Our Pune to Mira Road Cab Service offers reliable one-way and round-trip transportation with experienced drivers, clean AC vehicles, affordable fares, timely pickup, comfortable seating, highway assistance, and professional customer support for business, leisure, family, and corporate travel."
  },
  {
    "name": "Pune to Mira Road Taxi",
    "description": "Choose Pune to Mira Road Taxi for convenient long-distance travel with chauffeur-driven vehicles, fixed pricing, comfortable seating, safe highway journeys, and reliable transportation for business trips, airport transfers, and family travel."
  },
  {
    "name": "Pune to Mira Road Taxi Service",
    "description": "Book Pune to Mira Road Taxi Service with professional drivers, premium vehicles, punctual pickup, transparent fares, flexible booking, and dependable customer support for stress-free travel."
  },
  {
    "name": "Pune to Mira Road Cab Booking",
    "description": "Complete your Pune to Mira Road Cab Booking with instant confirmation, multiple vehicle choices, affordable pricing, doorstep pickup, and professional chauffeur service for a hassle-free travel experience."
  },
  {
    "name": "Online Pune to Mira Road Cab Booking",
    "description": "Use Online Pune to Mira Road Cab Booking to reserve your preferred cab quickly with instant confirmation, secure booking, transparent pricing, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Book Pune to Mira Road Cab",
    "description": "Book Pune to Mira Road Cab anytime for comfortable travel with experienced drivers, clean AC vehicles, affordable pricing, and dependable customer assistance throughout your journey."
  },
  {
    "name": "Pune to Mira Road One Way Cab",
    "description": "Choose Pune to Mira Road One Way Cab and pay only for your one-side journey while enjoying comfortable vehicles, experienced chauffeurs, transparent pricing, and reliable intercity transportation."
  },
  {
    "name": "Pune to Mira Road Round Trip Cab",
    "description": "Book Pune to Mira Road Round Trip Cab with flexible return timing, premium vehicles, affordable fares, experienced drivers, and comfortable travel for business or leisure."
  },
  {
    "name": "Pune to Mira Road Outstation Cab",
    "description": "Travel comfortably with Pune to Mira Road Outstation Cab featuring clean AC vehicles, professional chauffeurs, safe highway travel, flexible scheduling, and reliable long-distance transportation."
  },
  {
    "name": "Pune to Mira Road Car Rental",
    "description": "Choose Pune to Mira Road Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for family travel, corporate trips, airport transfers, and private transportation."
  },
  {
    "name": "Pune to Mira Road Private Cab",
    "description": "Hire Pune to Mira Road Private Cab for exclusive travel with flexible pickup, comfortable seating, privacy, experienced drivers, and premium intercity transportation."
  },
  {
    "name": "Pune to Mira Road AC Cab",
    "description": "Book Pune to Mira Road AC Cab with well-maintained air-conditioned vehicles, comfortable interiors, professional chauffeurs, and reliable long-distance travel service."
  },
  {
    "name": "Pune to Mira Road Intercity Cab",
    "description": "Our Pune to Mira Road Intercity Cab service offers safe, affordable, and convenient travel with experienced drivers, premium vehicles, and transparent pricing."
  },
  {
    "name": "Pune to Mira Road Drop Taxi",
    "description": "Choose Pune to Mira Road Drop Taxi for direct destination drop with affordable fares, professional drivers, clean AC vehicles, and dependable service."
  },
  {
    "name": "Pune to Mira Road Travel Cab",
    "description": "Book Pune to Mira Road Travel Cab for business trips, weekend outings, corporate travel, airport transfers, and family journeys with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Pune to Mira Road Taxi Booking",
    "description": "Complete your Pune to Mira Road Taxi Booking online with instant confirmation, transparent pricing, multiple vehicle options, and dependable taxi services."
  },
  {
    "name": "Pune to Mira Road Cab Hire",
    "description": "Hire Pune to Mira Road Cab with premium chauffeur-driven vehicles offering comfortable travel, affordable pricing, professional drivers, and 24x7 customer support."
  },
  {
    "name": "Pune to Mira Road Rental Cab",
    "description": "Choose Pune to Mira Road Rental Cab with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for convenient and flexible intercity travel."
  },
  {
    "name": "Mira Road to Pune Cab",
    "description": "Book Mira Road to Pune Cab for comfortable return travel with doorstep pickup, experienced chauffeurs, clean AC vehicles, affordable fares, and reliable intercity transportation."
  },
  {
    "name": "Pune to Mira Road Cab Fare",
    "description": "Check Pune to Mira Road Cab Fare with transparent pricing for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles without hidden charges."
  },
  {
    "name": "Pune to Mira Road Taxi Fare",
    "description": "View Pune to Mira Road Taxi Fare with affordable rates, multiple vehicle choices, fixed pricing, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Pune to Mira Road Cab Price",
    "description": "Find Pune to Mira Road Cab Price for one-way, round-trip, airport transfer, business travel, and private journeys with competitive rates."
  },
  {
    "name": "Pune to Mira Road Cab Charges",
    "description": "Know Pune to Mira Road Cab Charges with transparent billing, professional drivers, well-maintained vehicles, and no hidden costs."
  },
  {
    "name": "Pune to Mira Road Taxi Cost",
    "description": "Compare Pune to Mira Road Taxi Cost across Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles with economical pricing."
  },
  {
    "name": "Pune to Mira Road Cab Cost",
    "description": "Check Pune to Mira Road Cab Cost for business travel, family trips, corporate transportation, and private travel with affordable packages."
  },
  {
    "name": "Affordable Pune to Mira Road Cab",
    "description": "Book an Affordable Pune to Mira Road Cab with budget-friendly fares, experienced chauffeurs, premium vehicles, reliable service, and comfortable travel."
  },
  {
    "name": "Cheap Pune to Mira Road Cab",
    "description": "Choose Cheap Pune to Mira Road Cab with economical pricing, clean AC vehicles, professional drivers, and dependable intercity transportation."
  },
  {
    "name": "Lowest Fare Pune to Mira Road Cab",
    "description": "Get the Lowest Fare Pune to Mira Road Cab with competitive pricing, transparent billing, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Fixed Fare Pune to Mira Road Cab",
    "description": "Enjoy Fixed Fare Pune to Mira Road Cab service with upfront pricing, no hidden charges, premium cars, and professional drivers."
  },
  {
    "name": "Pune to Mira Road Cab Per Km",
    "description": "Check Pune to Mira Road Cab Per Km rates for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles with transparent fare calculation."
  },
  {
    "name": "Pune to Mira Road East Cab",
    "description": "Book Pune to Mira Road East Cab with comfortable AC vehicles, experienced chauffeurs, affordable pricing, and reliable travel service."
  },
  {
    "name": "Pune to Mira Road West Cab",
    "description": "Choose Pune to Mira Road West Cab for safe and convenient travel with professional drivers, premium vehicles, and fixed fare options."
  },
  {
    "name": "Pune to Mira Bhayandar Cab",
    "description": "Hire Pune to Mira Bhayandar Cab for smooth intercity transportation with comfortable vehicles, professional chauffeurs, and affordable fares."
  },
  {
    "name": "Pune to Bhayandar Cab",
    "description": "Book Pune to Bhayandar Cab with reliable pickup, clean AC vehicles, transparent pricing, and experienced drivers for business and family travel."
  },
  {
    "name": "Pune to Dahisar Cab",
    "description": "Travel with Pune to Dahisar Cab for comfortable intercity transportation featuring professional drivers, premium vehicles, and affordable fares."
  },
  {
    "name": "Pune to Kashimira Cab",
    "description": "Choose Pune to Kashimira Cab with reliable chauffeur service, clean vehicles, affordable pricing, and comfortable highway journeys."
  },
  {
    "name": "Pune to Naigaon Cab",
    "description": "Book Pune to Naigaon Cab with experienced drivers, AC vehicles, transparent pricing, and dependable intercity travel."
  },
  {
    "name": "Pune to Vasai Cab",
    "description": "Reserve Pune to Vasai Cab for affordable one-way, round-trip, and outstation travel with premium vehicles and professional chauffeurs."
  },
  {
    "name": "Pune to Borivali Cab",
    "description": "Book Pune to Borivali Cab for safe and convenient travel with experienced drivers, AC cars, affordable pricing, and flexible pickup options."
  },
  {
    "name": "Pune to Western Express Highway Cab",
    "description": "Choose Pune to Western Express Highway Cab for comfortable highway connectivity with professional chauffeurs, premium vehicles, and reliable transportation."
  },
  {
    "name": "Hinjewadi to Mira Road Cab",
    "description": "Book Hinjewadi to Mira Road Cab with doorstep pickup, comfortable AC vehicles, experienced drivers, and affordable one-way or round-trip travel."
  },
  {
    "name": "Wakad to Mira Road Cab",
    "description": "Choose Wakad to Mira Road Cab for reliable intercity travel with clean vehicles, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Baner to Mira Road Cab",
    "description": "Hire Baner to Mira Road Cab for safe, convenient, and comfortable travel with experienced drivers and premium vehicle options."
  },
  {
    "name": "Kharadi to Mira Road Cab",
    "description": "Book Kharadi to Mira Road Cab with reliable pickup, affordable fares, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Hadapsar to Mira Road Cab",
    "description": "Choose Hadapsar to Mira Road Cab with comfortable AC vehicles, experienced drivers, fixed fares, and dependable taxi service."
  },
  {
    "name": "Pimpri Chinchwad to Mira Road Cab",
    "description": "Book Pimpri Chinchwad to Mira Road Cab with premium vehicles, timely pickups, professional chauffeurs, and affordable travel packages."
  },
  {
    "name": "Viman Nagar to Mira Road Cab",
    "description": "Hire Viman Nagar to Mira Road Cab with chauffeur-driven vehicles, transparent pricing, and comfortable long-distance travel."
  },
  {
    "name": "Kothrud to Mira Road Cab",
    "description": "Book Kothrud to Mira Road Cab with clean AC vehicles, experienced drivers, affordable pricing, and reliable intercity transportation."
  },
  {
    "name": "Aundh to Mira Road Cab",
    "description": "Choose Aundh to Mira Road Cab with comfortable vehicles, punctual pickup, professional chauffeurs, and safe travel."
  },
  {
    "name": "Shivajinagar to Mira Road Cab",
    "description": "Book Shivajinagar to Mira Road Cab with doorstep pickup, premium AC vehicles, experienced drivers, transparent pricing, and dependable service."
  }
],

"tableData": [
  ["Pune to Mira Road Cab", "Pune to Mira Road Cab Service"],
  ["Pune to Mira Road Taxi", "Pune to Mira Road Taxi Service"],
  ["Pune to Mira Road Cab Booking", "Online Pune to Mira Road Cab Booking"],
  ["Book Pune to Mira Road Cab", "Pune to Mira Road One Way Cab"],
  ["Pune to Mira Road Round Trip Cab", "Pune to Mira Road Outstation Cab"],
  ["Pune to Mira Road Car Rental", "Pune to Mira Road Private Cab"],
  ["Pune to Mira Road AC Cab", "Pune to Mira Road Intercity Cab"],
  ["Pune to Mira Road Drop Taxi", "Pune to Mira Road Travel Cab"],
  ["Pune to Mira Road Taxi Booking", "Pune to Mira Road Cab Hire"],
  ["Pune to Mira Road Rental Cab", "Mira Road to Pune Cab"],
  ["Pune to Mira Road Cab Fare", "Pune to Mira Road Taxi Fare"],
  ["Pune to Mira Road Cab Price", "Pune to Mira Road Cab Charges"],
  ["Pune to Mira Road Taxi Cost", "Pune to Mira Road Cab Cost"],
  ["Affordable Pune to Mira Road Cab", "Cheap Pune to Mira Road Cab"],
  ["Lowest Fare Pune to Mira Road Cab", "Fixed Fare Pune to Mira Road Cab"],
  ["Pune to Mira Road Cab Per Km", "Pune to Mira Road East Cab"],
  ["Pune to Mira Road West Cab", "Pune to Mira Bhayandar Cab"],
  ["Pune to Bhayandar Cab", "Pune to Dahisar Cab"],
  ["Pune to Kashimira Cab", "Pune to Naigaon Cab"],
  ["Pune to Vasai Cab", "Pune to Borivali Cab"],
  ["Pune to Western Express Highway Cab", "Hinjewadi to Mira Road Cab"],
  ["Wakad to Mira Road Cab", "Baner to Mira Road Cab"],
  ["Kharadi to Mira Road Cab", "Hadapsar to Mira Road Cab"],
  ["Pimpri Chinchwad to Mira Road Cab", "Viman Nagar to Mira Road Cab"],
  ["Kothrud to Mira Road Cab", "Aundh to Mira Road Cab"],
  ["Shivajinagar to Mira Road Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Pune to Mira Road Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Pune to Mira Road cab services with comfortable vehicles for family visits, business travel, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Enjoy hassle-free pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations throughout Pune."
  },
  {
    WhyChooseheading: "Skilled Chauffeurs for Safe Travel",
    WhyChoosedescription: "Our experienced drivers ensure a secure, smooth, and punctual ride to Mira Road through the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Budget-Friendly Fare Plans",
    WhyChoosedescription: "Benefit from competitive cab fares with transparent pricing, detailed quotations, and no hidden charges."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel needs and group size."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Services",
    WhyChoosedescription: "Book one-way rides, return journeys, or customized travel packages with flexible pickup and drop schedules."
  },
  {
    WhyChooseheading: "Suitable for Business & Family Travel",
    WhyChoosedescription: "Our Pune to Mira Road cab service is ideal for office travel, residential transfers, hospital visits, shopping, and leisure trips."
  },
  {
    WhyChooseheading: "Quick Booking with 24/7 Assistance",
    WhyChoosedescription: "Receive instant fare estimates, immediate booking confirmation, and dedicated customer support anytime you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mira Road cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Mira Road cab services for one-way travel, round trips, airport transfers, business travel, and family journeys."
  },
  {
    question: "Can I book a one-way cab from Pune to Mira Road?",
    answer: "Yes, we provide affordable one-way cab services with doorstep pickup from any location across Pune."
  },
  {
    question: "Which vehicles are available for Pune to Mira Road travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable outstation travel."
  },
  {
    question: "Do you provide pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we offer pickup services from Pune Airport, Pune Railway Station, hotels, offices, and residential areas throughout Pune."
  },
  {
    question: "Can I reserve a round-trip cab to Mira Road?",
    answer: "Yes, Trustline Cab provides flexible round-trip cab packages tailored to your travel schedule."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Pune to Mira Road cab service available 24/7?",
    answer: "Yes, our cab services operate round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Is advance booking recommended for Pune to Mira Road cabs?",
    answer: "Yes, advance booking helps secure your preferred vehicle and ensures timely pickup."
  },
  {
    question: "Do you provide cabs for corporate and family travel?",
    answer: "Yes, our Pune to Mira Road cab service is suitable for business executives, families, tourists, and individual travelers."
  },
  {
    question: "How can I book a Pune to Mira Road cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Pawar",
    feedback: "Excellent coordination and punctual service made the Pune to Mira Road journey completely stress-free. The vehicle was well-maintained, and the driver ensured a smooth ride throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Mehta",
    feedback: "Trustline Travels delivered a professional travel experience with comfortable seating, courteous service, and timely arrival. Everything was managed efficiently from pickup to destination.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mira Road Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mira-road-cab.webp",
  "description": "Book Pune to Mira Road cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6429"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mira-road-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Mira Road Cab | One Way Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mira Road cab service with Trustline Travels for reliable intercity travel. Get affordable one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Mira Road Cab, Pune to Mira Road Cab Service, Pune to Mira Road Taxi, Pune to Mira Road Taxi Service, Pune to Mira Road Cab Booking, Online Pune to Mira Road Cab Booking, Book Pune to Mira Road Cab, Pune to Mira Road One Way Cab, Pune to Mira Road Round Trip Cab, Pune to Mira Road Outstation Cab, Pune to Mira Road Car Rental, Pune to Mira Road Private Cab, Pune to Mira Road AC Cab, Pune to Mira Road Intercity Cab, Pune Mira Road taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomiraroadcab;